<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte nov tip uporabnika:
    </h2>

    <UserTypeForm
      new="true"
      @save="save"
      @cancel="cancel"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import UserTypeForm from '@/components/UserTypeForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    UserTypeForm
  },
  mixins: [
    asyncDataStatus
  ],
  methods: {
    ...mapActions('userTypes', ['saveItem']),
    save ({ data }) {
      saveItem(data, 'MyCompanyUserTypes', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyUserTypes' })
    }
  },
  created () {
    this.asyncDataStatus_fetched()
  }
}
</script>
